import React from 'react';
import styled from '@emotion/styled';
import LogoMercadoPago from '../../../logo_mercadopago.svg';

const Button = styled.button`
  background: linear-gradient(to right, #009ee3, #00b1ea);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 2px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 100%;
  max-width: 370px;
  margin: 10px 0;

  &:hover {
    background: linear-gradient(to right, #008bd0, #009ee3);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const MercadoPagoButton = ({ onClick, disabled = false }) => {
  return (
    <Button onClick={onClick} disabled={disabled}>
      Pagar con
      <img src={LogoMercadoPago} width={150} />
    </Button>
  );
};

export default MercadoPagoButton;